import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { uiStore } from 'shared/store/uiStore'
import { Alert, Box, Button, SpinnerLoader, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  CompliancePageProvider,
  useComplianceLayerContext,
  useCompliancePageContext,
} from 'pages/settings/pages/compliance/context'
import styles from 'pages/settings/pages/compliance/ui/styles.module.scss'
import { CompliancePath } from 'pages/settings/pages/compliance/route/compliancePath'
import { Menu } from 'pages/settings/pages/compliance/ui/Menu/Menu'

const CompliancePageLayoutContent = observer(() => {
  const { complianceLayerStore } = useCompliancePageContext()
  const { usersStore, complianceStore } = useEntitiesContext()
  const { loading } = complianceLayerStore
  const {
    hasTaxID,
    isTaxIdBannerClosed,
    hasShowTaxIdBanner,
    closeComplianceTaxIdBannerSummary,
    businessTaxIDLink,
  } = complianceStore

  if (loading) return <SpinnerLoader ariaLabel={'compliancePageLayout'} />

  return (
    <div className={styles.wrap}>
      <div className={styles.content}>
        <Typography
          ariaLabel='ComplianceMainPageContext_title'
          variant='heading-lg'
          marginBottom={'3px'}
        >
          Compliance
        </Typography>
        <Typography
          ariaLabel='ComplianceMainPageContext_desc'
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
        >
          This is based on the number your business needs.
          {usersStore.user?.isRequireNumber && (
            <Button
              text='Edit'
              typeBtn='link'
              contained='secondary'
              paddingInline={0}
              className={styles.editBtn}
              onClick={() => {
                uiStore.changeRoute({
                  path: CompliancePath.compliance.questionnaire.root,
                })
              }}
            />
          )}
        </Typography>

        <Box display={'flex'} marginTop={!hasTaxID ? '24px' : '49px'} flexDirection={'column'}>
          {!hasTaxID && !isTaxIdBannerClosed && hasShowTaxIdBanner && (
            <Alert
              marginBottom={24}
              item={{
                type: 'warning',
                desc: 'Business Tax ID is required for sending text messages',
              }}
              rightActions={[
                {
                  variant: 'link',
                  type: 'primary',
                  text: 'Get a business Tax ID',
                  link: businessTaxIDLink,
                },
              ]}
              onClose={closeComplianceTaxIdBannerSummary}
            />
          )}
          <Box display={'flex'} alignItems={'flex-start'} gap={'40px'}>
            <Menu />
            <Box display={'flex'} flexDirection={'column'} width={'500px'} height='100%'>
              <Outlet />
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  )
})

export const CompliancePageLayout = () => {
  const complianceLayerStore = useComplianceLayerContext()

  return (
    <CompliancePageProvider complianceLayerStore={complianceLayerStore}>
      <CompliancePageLayoutContent />
    </CompliancePageProvider>
  )
}
